import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchSurvey, setResponse, fetchSurveyStats } from "Thunks";
import { setSelectedChoice } from "Actions";
import styles from "./Survey.local.scss";

import SurveyComponent from "./SurveyComponent";

class SurveyContainer extends Component {
  componentDidMount() {
    const { fetchSurvey } = this.props;
    fetchSurvey();
  }

  handleSelectResponse = (choice, e) => {
    const {
      setResponse,
      items,
      selectedChoice,
      fetchSurveyStats,
      setSelectedChoice
    } = this.props;
    if (selectedChoice) {
      return null;
    }
    const currentTarg = e.currentTarget;

    const instanceId = items[0].latestInstance.id;
    const questionId = items[0].dimensions[0].questions[0].id;

    const surveyArea = document.getElementsByClassName(styles.survey).item(0)
      .classList;
    surveyArea.add(styles.saving);
    setResponse({
      choice,
      instanceId,
      questionId
    }).then(resp => {
      if (
        resp &&
        resp.value &&
        resp.value.data &&
        resp.value.data.result &&
        resp.value.data.result === "OK"
      ) {
        setSelectedChoice(choice);
        currentTarg.classList.add(styles.selected);
        surveyArea.remove(styles.saving);
        fetchSurveyStats({
          instanceId,
          questionId
        });
      }
    });
  };

  render() {
    const {
      fetching,
      fetched,
      saving,
      saved,
      items,
      selectedChoice,
      lng,
      navCommunity,
      stats
    } = this.props;
    /*if (loggedAs !== "CLIENT") {
      return null;
    }*/

    return (
      <div className="cell medium-6 large-3">
        <SurveyComponent
          fetching={fetching}
          fetched={fetched}
          saving={saving}
          saved={saved}
          items={items}
          lng={lng}
          navCommunity={navCommunity}
          stats={stats}
          selectedChoice={selectedChoice}
          selectResponse={this.handleSelectResponse}
        />
      </div>
    );
  }
}
// Connected Component
const mapStateToProps = state => ({
  fetching: state.survey.fetching,
  fetched: state.survey.fetched,
  saving: state.survey.saving,
  saved: state.survey.saved,
  items: state.survey.items,
  stats: state.survey.stats,
  selectedChoice: state.survey.selectedChoice,
  lng: state.params.lng,
  navCommunity: state.auth.navCommunity
});

const mapDispatchToProps = dispatch => ({
  fetchSurvey: () => dispatch(fetchSurvey()),
  setResponse: response => dispatch(setResponse(response)),
  fetchSurveyStats: data => dispatch(fetchSurveyStats(data)),
  setSelectedChoice: choice => dispatch(setSelectedChoice(choice))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SurveyContainer);



// WEBPACK FOOTER //
// ./src/components/Community/ClientSpace/Survey/SurveyContainer.js